import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/profile-bg.jpg'
import _imports_1 from '@/assets/images/user-68.jpg'
import _imports_2 from '@/assets/images/check.svg'
import _imports_3 from '@/assets/images/user-7.jpg'
import _imports_4 from '@/assets/images/user-6.jpg'
import _imports_5 from '@/assets/images/user-8.jpg'
import _imports_6 from '@/assets/images/user-9.jpg'
import _imports_7 from '@/assets/images/user-10.jpg'
import _imports_8 from '@/assets/images/user-11.jpg'
import _imports_9 from '@/assets/images/user-12.jpg'
import _imports_10 from '@/assets/images/user-13.jpg'
import _imports_11 from '@/assets/images/user-14.jpg'
import _imports_12 from '@/assets/images/user-15.jpg'
import _imports_13 from '@/assets/images/product-6.jpg'
import _imports_14 from '@/assets/images/product-7.jpg'
import _imports_15 from '@/assets/images/product-8.jpg'
import _imports_16 from '@/assets/images/product-9.jpg'
import _imports_17 from '@/assets/images/product-10.jpg'
import _imports_18 from '@/assets/images/product-11.jpg'
import _imports_19 from '@/assets/images/product-12.jpg'
import _imports_20 from '@/assets/images/product-13.jpg'
import _imports_21 from '@/assets/images/product-14.jpg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-9" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 order-2" }
const _hoisted_5 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_6 = { class: "card-body p-0 pb-4" }
const _hoisted_7 = { class: "default-table-area style-two" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table align-middle border-0" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end pt-1" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end pt-1" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "col-lg-8 order-1" }
const _hoisted_21 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_22 = {
  class: "tab-pane fade show active",
  id: "timeline-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "timeline-tab",
  tabindex: "0"
}
const _hoisted_23 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_24 = { class: "card-body p-4" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-6 col-sm-6" }
const _hoisted_27 = { class: "col-lg-6 col-sm-6 mt-4 mt-sm-0" }
const _hoisted_28 = {
  class: "tab-pane fade",
  id: "about-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "about-tab",
  tabindex: "0"
}
const _hoisted_29 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_30 = { class: "card-body p-4" }
const _hoisted_31 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2 border-bottom pb-4 mb-4" }
const _hoisted_32 = { class: "dropdown action-opt ms-2 position-relative top-3" }
const _hoisted_33 = { class: "col-xxl-3" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-xxl-12 col-md-6" }
const _hoisted_36 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_37 = { class: "card-body p-0 pb-4" }
const _hoisted_38 = { class: "default-table-area style-two" }
const _hoisted_39 = { class: "table-responsive" }
const _hoisted_40 = { class: "table align-middle border-0" }
const _hoisted_41 = { class: "text-end pt-1" }
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = { class: "col-xxl-12 col-md-6" }
const _hoisted_47 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_48 = { class: "card-body p-0 pb-4" }
const _hoisted_49 = { class: "default-table-area style-two" }
const _hoisted_50 = { class: "table-responsive" }
const _hoisted_51 = { class: "table align-middle border-0" }
const _hoisted_52 = { class: "text-end pt-1" }
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = { class: "text-end" }
const _hoisted_55 = { class: "text-end" }
const _hoisted_56 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[30] || (_cache[30] = _createStaticVNode("<div class=\"position-relative\"><img src=\"" + _imports_0 + "\" class=\"rounded-top-3\" alt=\"profile-bg\"><div class=\"position-absolute\" style=\"bottom:25px;right:25px;\"><a href=\"#\" class=\"btn btn-outline-light text-white hover rounded-2\"> Update Cover Photo </a></div></div><div class=\"card bg-white border-0 rounded-3 mb-4 rounded-top-0\"><div class=\"card-body p-4\"><div class=\"d-flex justify-content-between flex-wrap gap-3\"><div class=\"d-flex align-items-end\"><div class=\"flex-shrink-0 position-relative mt-minus-110\"><img src=\"" + _imports_1 + "\" class=\"rounded-circle border border-2 wh-160\" alt=\"user\"><img src=\"" + _imports_2 + "\" class=\"position-absolute bottom-0 end-0\" alt=\"check\"></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"fs-24 mb-1\">Alice Johnson</h4><span class=\"fs-15 fw-medium\">Product designer</span></div></div><div class=\"d-flex align-items-center\"><a href=\"#\" class=\"btn btn-outline-light text-body fw-medium fs-16 px-4 hover hover-bg\"><i class=\"ri-edit-line fw-medium fs-18 me-2\"></i><span>Edit</span></a><a href=\"#\" class=\"btn btn-primary fw-medium fs-16 px-4 ms-3\"><i class=\"ri-share-fill fw-medium fs-18 me-2\"></i><span>Share</span></a></div></div></div></div>", 2)),
      _cache[31] || (_cache[31] = _createElementVNode("ul", {
        class: "nav nav-tabs profile-tabs border-0 justify-content-center gap-2 mb-4",
        id: "myTab",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link border-1 border-primary rounded-2 fw-medium active",
            id: "timeline-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#timeline-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "timeline-tab-pane",
            "aria-selected": "true"
          }, " Timeline ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link border-1 border-primary rounded-2 fw-medium",
            id: "about-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#about-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "about-tab-pane",
            "aria-selected": "false"
          }, " About ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link border-1 border-primary rounded-2 fw-medium",
            id: "activity-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#activity-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "activity-tab-pane",
            "aria-selected": "false"
          }, " Activity ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[20] || (_cache[20] = _createStaticVNode("<div class=\"p-4 pb-2\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4\"><h3 class=\"mb-0\">Friends</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Month</option><option value=\"1\">Last Month</option><option value=\"2\">Last Year</option></select></div><form class=\"position-relative default-src-form\"><input type=\"text\" class=\"form-control rounded-2\" placeholder=\"Search here\"><i class=\"material-symbols-outlined position-absolute top-50 start-0 translate-middle-y fs-18\"> search </i></form></div>", 1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("table", _hoisted_9, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_3,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Laura Martinez "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " laura@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[3] || (_cache[3] = _createElementVNode("td", { class: "pt-1" }, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Alex Davis"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " alex@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_11, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Mark Thompson "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " mark@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_12, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Rachel White"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " rachel@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Kevin Lee"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " kevin@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_14, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("td", { class: "pt-1" }, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Lenore Crum"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " crum@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_9,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-success border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Paul Bartlett "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " bartlett@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_10,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Nikki Lowe"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " lowe@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_17, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[17] || (_cache[17] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_11,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Milton Laskowski "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " laskowski@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[19] || (_cache[19] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0 position-relative" }, [
                              _createElementVNode("img", {
                                src: _imports_12,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              }),
                              _createElementVNode("div", { class: "position-absolute p-1 bg-danger border border-2 border-white rounded-circle status-position2" })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Ethel Hillen"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, " hillen@trezo.com ")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_19, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"card bg-white border-0 rounded-3 mb-4\"><div class=\"card-body p-4\"><h3 class=\"mb-3 mb-lg-4\">Create Post</h3><form><div class=\"mb-4\"><textarea class=\"form-control\" rows=\"6\" placeholder=\"What&#39;s on your mind, Alice Johnson?\"></textarea></div><div class=\"d-flex align-items-center gap-3\"><button class=\"btn btn-primary py-2 px-3 align-items-center d-flex fs-16 fw-medium\"><i class=\"material-symbols-outlined text-white me-2\"> send </i><span class=\"py-1 d-none d-sm-inline-block\"> Publish Post </span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-emotion-line\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-link-m\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-mic-line\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-image-line\"></i></button></div></form></div></div><div class=\"card bg-white border-0 rounded-3 mb-4\"><div class=\"card-body p-4\"><div class=\"d-flex justify-content-between align-items-center border-bottom pb-3 mb-3\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_4 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h6 class=\"mb-0 fs-14 fw-medium\">Cynthia Baggett</h6><span class=\"fs-13 text-body\">05 mins ago</span></div></a><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"save\"></i> Save Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye-off\"></i> Hide Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"flag\"></i> Report Photo </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block Cynthia </a></li></ul></div></div><p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p><p> It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions. </p><div class=\"border-top border-bottom py-2 my-4\"><div class=\"d-flex align-items-center justify-content-between flex-wrap gap-2\"><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-thumb-up-line\"></i><span class=\"fs-14 ms-2\">10 Likes</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-chat-4-line\"></i><span class=\"fs-14 ms-2\">0 Comments</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-share-line\"></i><span class=\"fs-14 ms-2\">0 Share</span></button></div></div><form><div class=\"d-flex justify-content-between align-items-center\"><div class=\"d-flex align-items-center text-decoration-none w-100\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-3 position-relative top-2\"><input type=\"text\" class=\"form-control\" placeholder=\"Type something....\"></div></div><div class=\"d-flex align-items-center gap-3 ms-3\"><button class=\"p-0 bg-primary border-0 wh-44 lh-56 rounded-2\"><i class=\"material-symbols-outlined text-white\">send</i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-emotion-line\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-link-m\"></i></button></div></div></form></div></div><div class=\"card bg-white border-0 rounded-3 mb-4\"><div class=\"card-body p-4\"><div class=\"d-flex justify-content-between align-items-center border-bottom pb-3 mb-3\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_3 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h6 class=\"mb-0 fs-14 fw-medium\">Douglas Hairston</h6><span class=\"fs-13 text-body\">1 hour ago</span></div></a><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"save\"></i> Save Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye-off\"></i> Hide Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"flag\"></i> Report Photo </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block Cynthia </a></li></ul></div></div><p> It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of lorem ipsum. </p><div class=\"border-top border-bottom py-2 my-4\"><div class=\"d-flex align-items-center justify-content-between flex-wrap gap-2\"><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-thumb-up-line\"></i><span class=\"fs-14 ms-2\">42 Likes</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-chat-4-line\"></i><span class=\"fs-14 ms-2\">2 Comments</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-share-line\"></i><span class=\"fs-14 ms-2\">1 Share</span></button></div></div><form><div class=\"d-flex justify-content-between align-items-center\"><div class=\"d-flex align-items-center text-decoration-none w-100\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-3 position-relative top-2\"><input type=\"text\" class=\"form-control\" placeholder=\"Type something....\"></div></div><div class=\"d-flex align-items-center gap-3 ms-3\"><button class=\"p-0 bg-primary border-0 wh-44 lh-56 rounded-2\"><i class=\"material-symbols-outlined text-white\"> send </i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-emotion-line\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-link-m\"></i></button></div></div></form></div></div><div class=\"card bg-white border-0 rounded-3 mb-4\"><div class=\"card-body p-4\"><div class=\"d-flex justify-content-between align-items-center border-bottom pb-3 mb-3\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_5 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h6 class=\"mb-0 fs-14 fw-medium\">Olivia John</h6><span class=\"fs-13 text-body\">1 day ago</span></div></a><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"save\"></i> Save Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye-off\"></i> Hide Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"flag\"></i> Report Photo </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block Cynthia </a></li></ul></div></div><p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry&#39;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </p><div class=\"border-top border-bottom py-2 my-4\"><div class=\"d-flex align-items-center justify-content-between flex-wrap gap-2\"><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-thumb-up-line\"></i><span class=\"fs-14 ms-2\">100 Likes</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-chat-4-line\"></i><span class=\"fs-14 ms-2\">16 Comments</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-share-line\"></i><span class=\"fs-14 ms-2\">5 Share</span></button></div></div><form><div class=\"d-flex justify-content-between align-items-center\"><div class=\"d-flex align-items-center text-decoration-none w-100\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-3 position-relative top-2\"><input type=\"text\" class=\"form-control\" placeholder=\"Type something....\"></div></div><div class=\"d-flex align-items-center gap-3 ms-3\"><button class=\"p-0 bg-primary border-0 wh-44 lh-56 rounded-2\"><i class=\"material-symbols-outlined text-white\">send</i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-emotion-line\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-link-m\"></i></button></div></div></form></div></div>", 4)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center border-bottom pb-3 mb-2\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_5 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-2 position-relative top-2\"><h6 class=\"mb-0 fs-14 fw-medium\">Olivia John</h6><span class=\"fs-13 text-body\">1 day ago</span></div></a><div class=\"dropdown action-opt\"><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i data-feather=\"more-horizontal\"></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"save\"></i> Save Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye-off\"></i> Hide Post </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"flag\"></i> Report Photo </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block Cynthia </a></li></ul></div></div><p>Our Author Products</p>", 2)),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_RouterLink, { to: "/ecommerce/product-details" }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createElementVNode("img", {
                            src: _imports_13,
                            class: "rounded-3",
                            alt: "product"
                          }, null, -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_RouterLink, { to: "/ecommerce/product-details" }, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("img", {
                            src: _imports_14,
                            class: "rounded-3",
                            alt: "product"
                          }, null, -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"border-top border-bottom py-2 my-4\"><div class=\"d-flex align-items-center justify-content-between flex-wrap gap-2\"><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-thumb-up-line\"></i><span class=\"fs-14 ms-2\">150 Likes</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-chat-4-line\"></i><span class=\"fs-14 ms-2\">17 Comments</span></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover align-items-center d-flex\"><i class=\"ri-share-line\"></i><span class=\"fs-14 ms-2\">7 Share</span></button></div></div><form><div class=\"d-flex justify-content-between align-items-center\"><div class=\"d-flex align-items-center text-decoration-none w-100\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"wh-44 rounded-circle\" alt=\"user\"></div><div class=\"flex-grow-1 ms-3 position-relative top-2\"><input type=\"text\" class=\"form-control\" placeholder=\"Type something....\"></div></div><div class=\"d-flex align-items-center gap-3 ms-3\"><button class=\"p-0 bg-primary border-0 wh-44 lh-56 rounded-2\"><i class=\"material-symbols-outlined text-white\"> send </i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-emotion-line\"></i></button><button class=\"p-0 bg-transparent border-0 fs-20 text-body hover\"><i class=\"ri-link-m\"></i></button></div></div></form>", 2))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "fs-18 mb-0" }, "About Me", -1)),
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_32, [...(_cache[26] || (_cache[26] = [
                      _createStaticVNode("<button class=\"p-0 border-0 bg-transparent\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\"><i class=\"material-symbols-outlined fs-20 fw-bold text-body hover\"> more_horiz </i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\"><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"eye\"></i> View All </a></li><li><a class=\"dropdown-item\" href=\"javascript:void(0);\"><i data-feather=\"edit\"></i> Edit </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"trash-2\"></i> Delete One </a></li><li><a class=\"dropdown-item\" href=\"javascript:;\"><i data-feather=\"lock\"></i> Block </a></li></ul>", 2)
                    ]))])), [
                      [
                        _directive_b_tooltip,
                        'More_Option',
                        void 0,
                        {
                          hover: true,
                          top: true
                        }
                      ]
                    ])
                  ]),
                  _cache[28] || (_cache[28] = _createStaticVNode("<h4 class=\"fs-16 fw-medium mb-2\">Introduction</h4><p class=\"mb-4\" style=\"max-width:691px;\"> Alice Johnson, a visionary UX/UI designer, blends creativity with user-centric design principles to craft seamless digital experiences. With a passion for innovation and a knack for understanding user needs, [Your Name] has become a driving force in the ever-evolving landscape of digital design. This 5000-word biography aims to delve into Alice&#39;s journey, from humble beginnings to becoming a recognized name in the realm of user experience and interface design. </p><h4 class=\"fs-16 fw-medium mb-2\">Professional Beginnings</h4><p class=\"mb-4\" style=\"max-width:691px;\"> Upon graduating, Alice embarked on their professional journey, eager to make an impact in the world of design. They initially gained experience working at VivoTech, where they collaborated with cross-functional teams to deliver user-centric solutions for various clients. This early exposure provided invaluable insights into the complexities of design processes and solidified Alice&#39;s commitment to enhancing user experiences. </p><h4 class=\"fs-16 fw-medium mb-2 pb-1\"> Expertise in UX/UI Design </h4><p style=\"max-width:691px;\"> Driven by a desire for continuous growth, Alice delved deeper into the nuances of UX/UI design, staying abreast of emerging trends, technologies, and methodologies. They immersed themselves in user research, wireframing, prototyping, and usability testing, refining their craft with each project. </p>", 6))
                ])
              ])
            ]),
            _cache[29] || (_cache[29] = _createElementVNode("div", {
              class: "tab-pane fade",
              id: "activity-tab-pane",
              role: "tabpanel",
              "aria-labelledby": "activity-tab",
              tabindex: "0"
            }, [
              _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4" }, [
                _createElementVNode("div", { class: "card-body p-4" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center justify-content-between mb-3" }, [
                    _createElementVNode("h3", { class: "mb-3 mb-lg-4" }, "Recent Activity"),
                    _createElementVNode("div", {
                      class: "dropdown action-opt ms-2 position-relative top-3",
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      "data-bs-title": "More Option"
                    }, [
                      _createElementVNode("button", {
                        class: "p-0 border-0 bg-transparent",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "material-symbols-outlined fs-20 text-body hover" }, " more_horiz ")
                      ]),
                      _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;"
                          }, [
                            _createElementVNode("i", { "data-feather": "eye" }),
                            _createTextVNode(" View All ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0);"
                          }, [
                            _createElementVNode("i", { "data-feather": "edit" }),
                            _createTextVNode(" Edit ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;"
                          }, [
                            _createElementVNode("i", { "data-feather": "trash-2" }),
                            _createTextVNode(" Delete One ")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:;"
                          }, [
                            _createElementVNode("i", { "data-feather": "lock" }),
                            _createTextVNode(" Block ")
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "position-relative timeline-item" }, [
                    _createElementVNode("span", { class: "time-line-date" }, "Just now"),
                    _createElementVNode("div", { class: "border-style-for-timeline" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-2" }, " Weekly Stand-Up Meetings: "),
                      _createElementVNode("p", { class: "fs-13" }, " We continued our weekly stand-up meetings where team members provided updates on their current tasks, discussed any roadblocks, and coordinated efforts for the week ahead. "),
                      _createElementVNode("p", null, [
                        _createTextVNode(" By: "),
                        _createElementVNode("span", { class: "text-primary" }, "Olivia Rodriguez")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "position-relative timeline-item" }, [
                    _createElementVNode("span", { class: "time-line-date" }, "1 day ago"),
                    _createElementVNode("div", { class: "border-style-for-timeline dot-2" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-2" }, " Project Kickoff Session: "),
                      _createElementVNode("p", { class: "fs-13" }, " The session included introductions, a review of project goals and objectives, and initial planning discussions. "),
                      _createElementVNode("p", null, [
                        _createTextVNode(" By: "),
                        _createElementVNode("span", { class: "text-primary" }, "Isabella Cooper")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "position-relative timeline-item" }, [
                    _createElementVNode("span", { class: "time-line-date" }, "2 days ago"),
                    _createElementVNode("div", { class: "border-style-for-timeline dot-3" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-2" }, " Team Building Workshop: "),
                      _createElementVNode("p", { class: "fs-13" }, " Last Friday, we conducted a team building workshop focused on improving communication and collaboration among team members. Activities included team challenges, icebreakers, and open discussions. "),
                      _createElementVNode("p", null, [
                        _createTextVNode("By: "),
                        _createElementVNode("span", { class: "text-primary" }, "Lucas Morgan")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "position-relative timeline-item" }, [
                    _createElementVNode("span", { class: "time-line-date" }, "3 days ago"),
                    _createElementVNode("div", { class: "border-style-for-timeline dot-4 pb-0" }, [
                      _createElementVNode("h4", { class: "fs-14 fw-medium mb-2" }, " Lunch and Learn Session: "),
                      _createElementVNode("p", { class: "fs-13" }, " We organized a lunch and learn session on March 15th where a guest speaker from the industry discussed emerging trends in our field. It was an insightful session that sparked valuable discussions among team members. "),
                      _createElementVNode("p", null, [
                        _createTextVNode("By: "),
                        _createElementVNode("span", { class: "text-primary" }, "Ethan Parker")
                      ])
                    ])
                  ])
                ])
              ])
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _cache[54] || (_cache[54] = _createStaticVNode("<div class=\"col-xxl-12 col-md-6\"><div class=\"card bg-white border-0 rounded-3 mb-4\"><div class=\"card-body p-4\"><h3 class=\"mb-4\">Profile Intro</h3><div class=\"d-flex align-items-center mb-4\"><div class=\"flex-shrink-0\"><img src=\"" + _imports_1 + "\" class=\"rounded-circle border border-2 wh-75\" alt=\"user\"></div><div class=\"flex-grow-1 ms-3\"><h4 class=\"fs-17 mb-1 fw-semibold\">Alice Johnson</h4><span class=\"fs-14\">Product designer</span></div></div><h4 class=\"fw-semibold fs-14 mb-2\">About Me</h4><p> Molestie tincidunt ut consequat a urna tortor. Vitae velit ac nisl velit mauris placerat nisi placerat. Pellentesque viverra lorem malesuada nunc tristique sapien. Imperdiet sit hendrerit tincidunt bibendum donec adipiscing. </p><h4 class=\"fw-semibold fs-14 mb-2 pb-1\">Social Profile</h4><ul class=\"ps-0 mb-0 list-unstyled d-flex flex-wrap gap-2\"><li><a href=\"https://www.facebook.com/\" target=\"_blank\" class=\"text-decoration-none wh-30 d-inline-block lh-30 text-center rounded-circle text-white transition-y\" style=\"background-color:#3a559f;\"><i class=\"ri-facebook-fill\"></i></a></li><li><a href=\"https://www.twitter.com/\" target=\"_blank\" class=\"text-decoration-none wh-30 d-inline-block lh-30 text-center rounded-circle text-white transition-y\" style=\"background-color:#03a9f4;\"><i class=\"ri-twitter-x-line\"></i></a></li><li><a href=\"https://www.linkedin.com/\" target=\"_blank\" class=\"text-decoration-none wh-30 d-inline-block lh-30 text-center rounded-circle text-white transition-y\" style=\"background-color:#007ab9;\"><i class=\"ri-linkedin-fill\"></i></a></li><li><a href=\"https://www.google.com/\" target=\"_blank\" class=\"text-decoration-none wh-30 d-inline-block lh-30 text-center rounded-circle text-white transition-y\" style=\"background-color:#2196f3;\"><i class=\"ri-mail-line\"></i></a></li></ul></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">Followers</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Month</option><option value=\"1\">Last Month</option><option value=\"2\">Last Year</option></select></div></div>", 1)),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("table", _hoisted_40, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[33] || (_cache[33] = _createElementVNode("td", { class: "pt-1" }, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_4,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Alex Davis"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "alex@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_41, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[35] || (_cache[35] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_3,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Laura Martinez "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "laura@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_42, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[37] || (_cache[37] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_5,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Mark Thompson "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "mark@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_43, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[39] || (_cache[39] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_6,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Rachel White"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "rachel@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_44, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_7,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Kevin Lee"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "kevin@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_45, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _cache[53] || (_cache[53] = _createStaticVNode("<div class=\"p-4\"><div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3\"><h3 class=\"mb-0\">Following</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-90\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>This Month</option><option value=\"1\">Last Month</option><option value=\"2\">Last Year</option></select></div></div>", 1)),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("table", _hoisted_51, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[44] || (_cache[44] = _createElementVNode("td", { class: "pt-1" }, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_8,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Lenore Crum"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "crum@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_52, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[46] || (_cache[46] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_9,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Paul Bartlett "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "bartlett@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_53, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[48] || (_cache[48] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_10,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Nikki Lowe"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "lowe@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_54, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[50] || (_cache[50] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_11,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, " Milton Laskowski "),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "laskowski@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_55, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[52] || (_cache[52] = _createElementVNode("td", null, [
                          _createElementVNode("div", { class: "d-flex align-items-center" }, [
                            _createElementVNode("div", { class: "flex-shrink-0" }, [
                              _createElementVNode("img", {
                                src: _imports_12,
                                class: "wh-44 rounded-circle",
                                alt: "user"
                              })
                            ]),
                            _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                              _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Ethel Hillen"),
                              _createElementVNode("span", { class: "fs-12 text-body" }, "hillen@trezo.com")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("td", _hoisted_56, [
                          _createVNode(_component_RouterLink, {
                            to: "/my-profile",
                            class: "wh-35 d-inline-block border text-center lh-35 rounded-circle text-decoration-none hover-bg"
                          }, {
                            default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                              _createElementVNode("i", { class: "ri-arrow-right-up-line fs-18" }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _cache[55] || (_cache[55] = _createStaticVNode("<div class=\"col-xxl-12 col-md-6\"><div class=\"card bg-white border-0 rounded-3 mb-4\"><div class=\"card-body p-4 pb-2\"><h3 class=\"mb-lg-4 mb-3\">Photos</h3><div class=\"row\" style=\"--bs-gutter-x:15px;\"><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_13 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_14 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_15 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_16 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_17 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_18 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_19 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_20 + "\" class=\"rounded-2\" alt=\"product\"></a></div><div class=\"col-lg-4 col-sm-4\"><a href=\"#\" class=\"d-block mb-3\"><img src=\"" + _imports_21 + "\" class=\"rounded-2\" alt=\"product\"></a></div></div></div></div></div>", 1))
      ])
    ])
  ]))
}